import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$locale/_dashboard/onboarding")({
  component: OnboardingPage,
});

function OnboardingPage() {
  return (
    <div className="py-6">
      <h1 className="text-2xl font-semibold">Onboarding</h1>
      <p className="text-muted-foreground mt-2">
        Get started with Alkana.
      </p>
    </div>
  );
}
